import { render, staticRenderFns } from "./FormIssuesAndNeeds.vue?vue&type=template&id=027f74ee&scoped=true&"
import script from "./FormIssuesAndNeeds.vue?vue&type=script&lang=js&"
export * from "./FormIssuesAndNeeds.vue?vue&type=script&lang=js&"
import style0 from "./FormIssuesAndNeeds.vue?vue&type=style&index=0&id=027f74ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f74ee",
  null
  
)

export default component.exports